import React from 'react';
import PropTypes from 'prop-types';

import {
  PROPERTY_ATTRIBUTE_LEVEL_APARTMENT,
  PROPERTY_ATTRIBUTE_LEVEL_APARTMENT_BUILDING,
  PROPERTY_ATTRIBUTE_LEVEL_FLOOR_PLAN,
} from 'common/propertyAttributeConstants';

import SrMarkdown, {
  SR_MARKDOWN_THEME_PROPERTY_FEATURES,
} from 'client/components/SrMarkdown';

const SrPropertyFeaturesBlock = ({ propertyFeatures }) => {
  const propertyFeaturesByName = propertyFeatures.reduce((memo, { name, attrs }) => ({
    ...memo,
    [name]: attrs.value,
  }), {});
  const mardown = [
    propertyFeaturesByName[PROPERTY_ATTRIBUTE_LEVEL_APARTMENT],
    propertyFeaturesByName[PROPERTY_ATTRIBUTE_LEVEL_APARTMENT_BUILDING],
    propertyFeaturesByName[PROPERTY_ATTRIBUTE_LEVEL_FLOOR_PLAN],
  ].filter((x) => x).join('\n');

  return (
    <SrMarkdown
      source={mardown}
      theme={SR_MARKDOWN_THEME_PROPERTY_FEATURES}
      escapeHtml={false}
    />
  );
};

SrPropertyFeaturesBlock.propTypes = {
  propertyFeatures: PropTypes.array.isRequired,
};

SrPropertyFeaturesBlock.displayName = 'SrPropertyFeaturesBlock';

export default SrPropertyFeaturesBlock;
